import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Button, Card, Col, Divider, Input, message, Modal, Row, Select, Table } from 'antd';
import { Link } from 'react-router-dom';
import { DOMAIN, getData, usuario } from '../../../resources';
import Phq9Results from './keta/phq9-results';
import Gad7Results from './keta/gad-7-calc';
import CadsResults from './keta/cads-results';
import CssrsResults from './keta/cssrs-results';
import SatisfaccionResults from './keta/satisfaccion-results';
import DocsCalc from './keta/docs.results';
import SarsResults from './emt/sars-results';
import DolorResults from './emt/dolor-results';
import { useHistory } from 'react-router-dom';
import ThiResults from './emt/thi-results';
import Pcl5Results from './emt/pcl5-results';
import InsomnioResults from './emt/insomnio-results';
import EmcaResults from './emt/emca-results';
import OwsResults from './emt/ows-results';


// Must access to this view from the visitas.jsx#DetailsEMT

// Table that shows the EMT scales of a patient 

// Contains the modal that shows the details of each EMT scale

export default function EscalasEMT() {

    // Populate table void
    const { state } = useLocation();
    const session = state.session;
    const id_visita = state.visita._id;

    const [encuestaDetailsOpen, setEncuestaDetailsOpen] = useState(false)
    const [encuestaDetails, setEncuestaDetails] = useState({})

    const [encuestaNotExists, setEncuestaNotExists] = useState(false);
    const [checking, setChecking] = useState(false);

    const copyTextToClipboard = ({ tipo, session, protocolo }) => {
        const link = `${DOMAIN}${tipo}_public/${usuario._id}/${state.visita.id_paciente}/EMT/${id_visita}/${session}/${protocolo}/`;
        navigator.clipboard.writeText(link)
        message.success('Enlace copiado al portapapeles');
    }

    const checkEncuesta = (tipo, protocolo) => {

        const URL_TO_SEARCH = `encuestas/find/${state.visita.id_paciente}/${id_visita}/${tipo}/${session}/${protocolo}`
        console.log('searching', URL_TO_SEARCH)
        getData(URL_TO_SEARCH).then(rs => {
            console.log('response at search ', rs)
            if (rs.message === 'The survey does not exist')
                copyTextToClipboard({ tipo, session, protocolo })
            else {
                setEncuestaDetails(rs)
                setEncuestaDetailsOpen(true)
            }
        })
    }

    // Populate table void - End



    // Fetch the new table of completed scales

    const [scalesTableFetched, setScalesTableFetched] = useState([])

    useEffect(() => {
        const fetchTable = () => {
            const url = `/encuestas/table/${state.visita.id_paciente}/${state.visita._id}/${session}`
            console.log('Fetching table: ', url)
            getData(url).then(setScalesTableFetched)
        }
        fetchTable()
    }, [])


    const getResultado = (tipo, protocolo) => {

        // Buscar en los datos del API
        const item = scalesTableFetched.find(data =>
            data.tipo === tipo &&
            data.protocolo === protocolo
        );

        console.log(`item found ${tipo} ${protocolo}`, item || 'not found')

        return item ? item.resultado : '🔴';
    };
    // Fetch the new table of completed scales - End

    const dataSource = [ // Must change for table fetched
        {
            key: '1',
            protocolo: 'DRT',
            tipo: 'PHQ-9',
            resultado: <span onClick={() => checkEncuesta('phq9p', 'DRT')} style={{ cursor: 'pointer' }}>{getResultado('phq9p', 'DRT')}</span>,

        },
        {
            key: '2',
            protocolo: 'DRT',
            tipo: 'GAD-7',
            resultado: <span onClick={() => checkEncuesta('gad_7', 'DRT')} style={{ cursor: 'pointer' }}>{getResultado('gad_7', 'DRT')}</span>,
        },
        {
            key: '3',
            protocolo: 'Ansiedad',
            tipo: 'GAD-7',
            resultado: <span onClick={() => checkEncuesta('gad_7', 'Ansiedad')} style={{ cursor: 'pointer' }}>{getResultado('gad_7', 'Ansiedad')}</span>,
        },
        {
            key: '4',
            protocolo: 'Ansiedad',
            tipo: 'PHQ-9',
            resultado: <span onClick={() => checkEncuesta('phq9p', 'Ansiedad')} style={{ cursor: 'pointer' }}>{getResultado('phq9p', 'Ansiedad')}</span>,
        },
        {
            key: '5',
            protocolo: 'Burnout',
            tipo: 'PHQ-9',
            resultado: <span onClick={() => checkEncuesta('phq9p', 'Burnout')} style={{ cursor: 'pointer' }}>{getResultado('phq9p', 'Burnout')}</span>,
        },
        {
            key: '6',
            protocolo: 'Burnout',
            tipo: 'GAD-7',
            resultado: <span onClick={() => checkEncuesta('gad_7', 'Burnout')} style={{ cursor: 'pointer' }}>{getResultado('gad_7', 'Burnout')}</span>,
        },
        {
            key: '7',
            protocolo: 'TOC',
            tipo: 'GAD-7',
            resultado: <span onClick={() => checkEncuesta('gad_7', 'TOC')} style={{ cursor: 'pointer' }}>{getResultado('gad_7', 'TOC')}</span>,
        },
        {
            key: '8',
            protocolo: 'TOC',
            tipo: 'PHQ-9',
            resultado: <span onClick={() => checkEncuesta('phq9p', 'TOC')} style={{ cursor: 'pointer' }}>{getResultado('phq9p', 'TOC')}</span>,
        },
        {
            key: '9',
            protocolo: 'TOC',
            tipo: 'DOCS',
            resultado: <span onClick={() => checkEncuesta('docs', 'TOC')} style={{ cursor: 'pointer' }}>{getResultado('docs', 'TOC')}</span>,
        },
        {
            key: '10',
            protocolo: 'Uso de sustancias',
            tipo: 'PHQ-9',
            resultado: <span onClick={() => checkEncuesta('phq9p', 'Uso de sustancias')} style={{ cursor: 'pointer' }}>{getResultado('phq9p', 'Uso de sustancias')}</span>,
        },
        {
            key: '11',
            protocolo: 'Uso de sustancias',
            tipo: 'GAD-7',
            resultado: <span onClick={() => checkEncuesta('gad_7', 'Uso de sustancias')} style={{ cursor: 'pointer' }}>{getResultado('gad_7', 'Uso de sustancias')}</span>,
        },
        {
            key: '12',
            protocolo: 'Tinnitus',
            tipo: 'THI',
            resultado: <span onClick={() => checkEncuesta('thi', 'Tinnitus')} style={{ cursor: 'pointer' }}>{getResultado('thi', 'Tinnitus')}</span>,
        },
        {
            key: '13',
            protocolo: 'Estres post-traumatico',
            tipo: 'PCL-5',
            resultado: <span onClick={() => checkEncuesta('pcl_5', 'Estres post-traumatico')} style={{ cursor: 'pointer' }}>{getResultado('pcl_5', 'Estres post-traumatico')}</span>,
        },
        {
            key: '14',
            protocolo: 'TDAH',
            tipo: 'SARS',
            resultado: <span onClick={() => checkEncuesta('sars', 'TDAH')} style={{ cursor: 'pointer' }}>{getResultado('sars', 'TDAH')}</span>,
        },
        {
            key: '15',
            protocolo: 'Insomnio',
            tipo: 'Insomnio',
            resultado: <span onClick={() => checkEncuesta('insomnio', 'Insomnio')} style={{ cursor: 'pointer' }}>{getResultado('insomnio', 'Insomnio')}</span>,
        },
        {
            key: '16',
            protocolo: 'Dolor cronico',
            tipo: 'dolor',
            resultado: <span onClick={() => checkEncuesta('dolor_2', 'DOLOR')} style={{ cursor: 'pointer' }}>{getResultado('dolor_2', 'DOLOR')}</span>,
        },
        {
            key: '17',
            protocolo: 'Uso de sustancias',
            tipo: 'emca',
            resultado: <span onClick={() => checkEncuesta('emca', 'sustancias')} style={{ cursor: 'pointer' }}>{getResultado('emca', 'sustancias')}</span>,
        },
        {
            key: '18',
            protocolo: 'Uso de opiaceos',
            tipo: 'ows',
            resultado: <span onClick={() => checkEncuesta('ows', 'opiaceos')} style={{ cursor: 'pointer' }}>{getResultado('ows', 'opiaceos')}</span>,
        }

    ];


    const columns = [
        {
            title: 'Protocolo',
            dataIndex: 'protocolo',
            key: 'protocolo',
            width: '20%',
        },
        {
            title: 'Escala',
            dataIndex: 'tipo',
            key: 'tipo',
        },
        {
            title: 'Resultado',
            dataIndex: 'resultado',
            key: 'resultado',
        }
    ];


    // USED FOR THE TABLE NESTED INSIDE

    const [patientData, setPatientData] = useState({})

    useEffect(() => {
        const fetchPatientData = () => {
            const url = `/getuser/${state.visita.id_paciente}`
            console.log('Fetching patient data: ', url)
            getData(url).then(setPatientData)
        }
        fetchPatientData()
    }, [])

    const calculateEMTResults = () => {
        switch (encuestaDetails[0].tipo) {
            case 'phq9p':
                return <Phq9Results phq9={encuestaDetails[0].phq9p} pacienteData={patientData} fecha={encuestaDetails[0].createdAt} />
            case 'gad_7':
                return <Gad7Results gad7={encuestaDetails[0].gad_7} pacienteData={patientData} fecha={encuestaDetails[0].createdAt} />
            case 'cadss':
                return <CadsResults cads={encuestaDetails[0].cadss} pacienteData={patientData} fecha={encuestaDetails[0].createdAt} />
            case 'cssrs':
                return <CssrsResults cssrs={encuestaDetails[0].cssrs} pacienteData={patientData} fecha={encuestaDetails[0].createdAt} />
            case 'satisfaccion':
                return <SatisfaccionResults satisfaccion={encuestaDetails[0].encuesta_satisfaccion} pacienteData={patientData} fecha={encuestaDetails[0].createdAt} />
            case 'docs':
                return <DocsCalc docs={encuestaDetails[0].docs} />
            case 'sars':
                return <SarsResults sars={encuestaDetails[0].sars} />
            case 'dolor_2':
                return <DolorResults escalaDetails={encuestaDetails[0].dolor_2} />
            case 'thi':
                return <ThiResults thi={encuestaDetails[0].thi} />
            case 'pcl_5':
                return <Pcl5Results pcl5={encuestaDetails[0].pcl_5} />
            case 'insomnio':
                return <InsomnioResults insomnio={encuestaDetails[0].insomnio} />
            case 'emca':
                return <EmcaResults emca={encuestaDetails[0].emca} pacienteData={patientData} fecha={encuestaDetails[0].createdAt} />
            case 'ows':
                return <OwsResults ows={encuestaDetails[0].ows} />
            default:
                return null

        }
    }

    const history = useHistory();

    const backToPrevous = () => {
        history.push("pacientes", { name: patientData.name });
    }
    return (
        <div className='mainContainer'>
            {/* <Button type='link' onClick={backToPrevous}>❮ Regresar</Button> */}
            <Link to={{
                pathname: "/pacientes",
                state: { name: patientData.name }
            }}>
                ❮ Regresar
            </Link>
            <div style={{ height: '8px' }}></div>
            <h4>Escalas EMT</h4>
            <p className='nombre'>Paciente: {patientData.name}</p>
            <p className='nombre'>Sesión {session}</p>


            <Table dataSource={dataSource} columns={columns} />

            {/* <div>This session visits</div>
            <div>{JSON.stringify(scalesTableFetched)}</div>
            <Table dataSource={scalesTableFetched} columns={columns} /> */}

            <Modal
                title="Detalles de la encuesta"
                open={encuestaDetailsOpen}
                onOk={() => setEncuestaDetailsOpen(false)}
                onCancel={() => setEncuestaDetailsOpen(false)}
                width={900}
            >
                {/* Contains the EMT Results emt results */}
                {/* {JSON.stringify(encuestaDetails)} */}
                <p>Escala: {encuestaDetails[0]?.tipo}</p>
                <p>Fecha: {new Date(encuestaDetails[0]?.createdAt).toLocaleString()}</p>
                {
                    encuestaDetails[0]?.tipo && calculateEMTResults()
                }
            </Modal>
        </div>
    )
}
const styles = {
    resultSpan: {
        cursor: 'pointer',
        width: '20px',
        height: '20px',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
};
